var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"1000","opacity":"0.15"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"80","color":"primary"}})],1),(_vm.isOffline)?_c('offline-screen'):[_c('app-bar'),_c('app-drawer'),_c('app-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }